module.exports = __webpack_public_path__ + "img/2022-06-02_14-05-29.05dd6df8.jpg";